import styled, {css} from 'styled-components';

import {flexCenter} from '../../../../libs/shared/ui/src/styles/mixins';
import {boxShadow} from '../../../../libs/shared/ui/src/theme/themeStyleHelpers';

/*
 * Constants.
 */

export const MAX_REPORT_PANEL_WIDTH = 1200;

export const CONVERSATION_CARD_HEIGHT = 98;

/*
 * Styled components.
 */

export const StyledFlex = styled.div`
  ${flexCenter};
`;

export const StyledElementWrapper = styled.div`
  flex: 1;
  min-height: 0;
`;

export const StyledEllipsisWrapperDiv = styled.div`
  ${flexCenter}
  overflow: hidden;
`;

/*
 * Mixins.
 */

export const reportInnerContent = css`
  max-width: ${MAX_REPORT_PANEL_WIDTH}px;
  margin-left: auto;
  margin-right: auto;
`;

export const sidePanelConversationCard = css`
  padding: 14px 14px 16px 16px;
  margin-bottom: 8px;

  border: 1px solid ${(p) => p.theme.alphas.black30};
  ${(p) => boxShadow(p.theme, `0px 1px 1px ${p.theme.alphas.black10}`)};
  border-radius: 8px;
  background-color: ${(p) => p.theme.greys.white};
`;
